// @flow
import React, { Component } from 'react';

import './ContactForm.css';
import ContactService from '../../services/contact';
import ContactInfo from '../ContactInfo/ContactInfo';
// import ContactSuccess from '../ContactSuccess/ContactSuccess';
// import ContactError from '../ContactError/ContactError';
import Loader from '../Loader/Loader';


export default class ContactForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            fields: {
                first_name: '',
                last_name: '',
                email: '',
                subject: '',
                website: '',
                message: '',
            },
            wasSent: false,
            sending: false,
            failed: false,
            errors: {},
        };

        this.contactService = new ContactService();

        // -- binding event handlers
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

    }


    handleSubmit (event) {
        event.preventDefault();

        this.setState({ sending: true });
        this.contactService.send(this.state.fields)
            .then(() => {
                this.setState({
                    wasSent: true,
                    sending: false,
                });
            })
            .catch((res) => {
                if (res.status === 500) {
                    this.setState({
                        wasSent: false,
                        failed: true,
                        sending: false,
                    });

                } else {
                    this.setState({
                        wasSent: false,
                        sending: false,
                        errors: res.data,
                    });

                }
            })

    }


    handleInputChange (event) {
        let name = event.target.name,
            value = event.target.value;

        this.setState((prevState, props) => {
            prevState.fields[name] = value;

            // -- reset errors
            prevState.errors[name] = [];

            return { fields: prevState.fields };
        });
    }

    /*
        Renderers
    */
    renderFirstName () {
        let error = this.renderError(this.state.errors.first_name, 1, 50);

        return (
            <div className="input-field col s6">
                <input
                    onChange={ this.handleInputChange }
                    name="first_name"

                    required
                    id="first_name"
                    type="text"
                    className={ error ? "invalid": "" }></input>
                <label
                    htmlFor="first_name">
                    Imię (wymagane)</label>
                { error }
            </div>);
    }


    renderLastName () {
        let error = this.renderError(this.state.errors.last_name, 1, 50);

        return (
            <div className="input-field col s6">
                <input
                    onChange={ this.handleInputChange }
                    name="last_name"

                    id="last_name"
                    type="text"
                    className={ error ? "invalid": "" }></input>
                <label
                    htmlFor="last_name">
                    Nazwisko (wymagane)</label>
                { error }
            </div>);
    }


    renderEmail () {
        let error = this.renderError(this.state.errors.email, 0, undefined);

        return (
            <div className="input-field col s6">
                <input
                    onChange={ this.handleInputChange }
                    name="email"

                    required
                    id="email"
                    type="email"
                    className={ error ? "invalid": "" }></input>
                <label
                    htmlFor="email">
                    Email (wymagany)</label>
                { error }
            </div>);
    }


    renderWebsite () {
        let error = this.renderError(this.state.errors.website, 0, undefined);

        return (
            <div className="input-field col s6">
                <input
                    onChange={ this.handleInputChange }
                    name="website"

                    id="website"
                    type="url"
                    className={ error ? "invalid": "" }></input>
                <label
                    htmlFor="website">
                    Twoja Strona
                </label>
                { error }
            </div>);
    }


    renderSubject() {
        let error = this.renderError(this.state.errors.subject, 0, 200);

        return (
            <div className="input-field col s12">
                <input
                    onChange={ this.handleInputChange }
                    name="subject"

                    id="subject"
                    type="text"
                    className={ error ? "invalid": "" }></input>
                <label
                    htmlFor="subject">
                    Temat
                </label>
                { error }
            </div>);
    }


    renderMessage() {
        let error = this.renderError(this.state.errors.message, 2, 2000);

        return (
            <div className="input-field col s12">
                <textarea
                    onChange={ this.handleInputChange }
                    name="message"

                    id="message"
                    className={ 'materialize-textarea ' + (error ? "invalid": "") }>
                </textarea>
                <label
                    htmlFor="message">
                    Wiadomość (wymagana)
                </label>
                { error }
            </div>);
    }


    renderError (errors, minLen, maxLen) {

        let errorMsg = null;

        if (errors && errors[0] !== undefined) {
            let error = errors[0];

            if (error.indexOf('not be blank') >= 0) {
                errorMsg = 'To pole jest wymagane';
            }

            if (error.indexOf('valid') >= 0) {
                errorMsg = 'Wpisz poprawną wartość';
            }

            if (error.indexOf('at least') >= 0) {
                errorMsg = `Za mało znaków, minimum to ${minLen}`;
            }

            if (error.indexOf('no more than') >= 0) {
                errorMsg = `Za dużo znaków, maksimum to ${maxLen}`;
            }
        }

        if (errorMsg !== null) {
            return (
                <span
                    className="ln-error">
                    { errorMsg }
                </span>);
        }

        return null;

    }


    renderLoader() {
        if (this.state.sending) {
            return (
                <div
                    className="ln-contact-loader">
                    <Loader message="wysyłam ..." />
                </div>);
        }
    }


    render () {
        // let main;

        // if (this.state.wasSent) {
        //     main = <ContactSuccess />;

        // } else if (this.state.failed) {
        //     main = <ContactError />;

        // } else {
        //     main = (
        //         <div
        //             className="row ln-contact-form">
        //             <form>
        //                 <div className="row">
        //                     { this.renderFirstName() }
        //                     { this.renderLastName() }
        //                 </div>

        //                 <div className="row">
        //                     { this.renderEmail() }
        //                     { this.renderWebsite() }
        //                 </div>

        //                 <div className="row">
        //                     { this.renderSubject() }
        //                 </div>

        //                 <div className="row">
        //                     { this.renderMessage() }
        //                 </div>

        //                 <div className="row center">
        //                     <button
        //                         onClick={ this.handleSubmit }
        //                         className="btn waves-effect waves-light"
        //                         type="submit"
        //                         name="action">
        //                         wyślij
        //                         <i className="material-icons right">send</i>
        //                       </button>
        //                 </div>
        //             </form>
        //             { this.renderLoader() }
        //         </div>);
        // }

        return (
            <div className="row ln-contact">
                <div className="col s12 m6">
                    <img
                        src="/contact.png"
                        alt="get in touch" />
                </div>

                <div
                    className="col s12 m6">
                    <ContactInfo />

                </div>
            </div>);
            // {main}
    }
}



// WEBPACK FOOTER //
// ./src/components/ContactForm/ContactForm.js